import { createContext, useContext } from 'react';

export class FormStatusDefinition {
  hasChange = false
}

export class FormContextDefinition {
  status = new FormStatusDefinition;
  handleStatus = () => { }
}

export const FormContext = createContext(new FormContextDefinition)
export const useStatusForm = () => useContext(FormContext)
